var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecentSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97571 17.167C13.8952 17.167 17.0725 13.9896 17.0725 10.0702C17.0725 6.15073 13.8952 2.97339 9.97571 2.97339C6.05625 2.97339 2.87891 6.15073 2.87891 10.0702C2.87891 13.9896 6.05625 17.167 9.97571 17.167ZM9.97571 19.167C14.9997 19.167 19.0725 15.0942 19.0725 10.0702C19.0725 5.04617 14.9997 0.973389 9.97571 0.973389C4.95168 0.973389 0.878906 5.04617 0.878906 10.0702C0.878906 15.0942 4.95168 19.167 9.97571 19.167Z",
    fill: "#9CA0A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78689 6.00264C8.78689 5.49177 9.20103 5.07764 9.71189 5.07764C10.2228 5.07764 10.6369 5.49177 10.6369 6.00264V11.1465C10.6369 11.6573 10.2228 12.0715 9.71189 12.0715C9.20103 12.0715 8.78689 11.6573 8.78689 11.1465V6.00264Z",
    fill: "#9CA0A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17592 11.891C8.79399 11.5517 8.75941 10.9671 9.09869 10.5851C9.43797 10.2032 10.0226 10.1686 10.4046 10.5079L12.8084 12.6433C13.1903 12.9826 13.2249 13.5672 12.8856 13.9492C12.5464 14.3311 11.9617 14.3657 11.5798 14.0264L9.17592 11.891Z",
    fill: "#9CA0A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentSearchIcon);
export default __webpack_public_path__ + "static/media/Recent_Search_Icon.5dcda519ab572c6b90984a43188e3ba0.svg";
export { ForwardRef as ReactComponent };